import api from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function getAdminPushState() {
  if (!pushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  try {
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    const sub = reg && (await reg.pushManager.getSubscription());
    return sub ? "on" : "off";
  } catch { return "off"; }
}

// Registra sw.js, chiede il permesso e salva la subscription lato admin
export async function enableAdminPush() {
  if (!pushSupported()) throw new Error("Push non supportate su questo browser");
  const perm = Notification.permission === "granted" ? "granted" : await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso notifiche negato");
  const reg = (await navigator.serviceWorker.getRegistration("/sw.js")) || (await navigator.serviceWorker.register("/sw.js"));
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/public/push/vapid-public-key");
    if (!data.key) throw new Error("Push non configurate sul server (VAPID)");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(data.key) });
  }
  await api.post("/push/admin-subscribe", { subscription: sub.toJSON() });
  return sub;
}

export async function disableAdminPush() {
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) {
    await api.post("/push/admin-unsubscribe", { subscription: sub.toJSON() }).catch(() => {});
    await sub.unsubscribe();
  }
}
